import api from "../../Api/feathers-client";

// Call backend service to authenticate
export const authenticate = async (username, password) => {
  return new Promise(async (resolve, reject) => {
    try {
      let authResponse = await api.authenticate({
        strategy: "local",
        username: username,
        password: password,
      });
      resolve(authResponse);
    } catch (error) {
      api.authentication.reset();
      resolve(error);
    }
  });
};

// Call backend service to validate new user passcode
export const validatePasscode = async (passcode) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("validateUsersFromPasscode").find({
        query: {
          passcode,
        },
      });

      console.log("response", response);
      if (response["data"].length == 0) {
        resolve({
          status: 401,
          message: "Invalid Passcode",
        });
      }
      resolve({
        status: 200,
        message: "Valid Passcode",
        data: response["data"],
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to set username & password
export const setNewCredentials = async (username, password, site_uuid, uid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("validateUsersFromPasscode").patch(
        null,
        {
          username,
          password,
          passcode: null,
        },
        {
          query: {
            site_uuid,
            uid,
          },
        }
      );

      console.log("response", response);
      if (response.length == 0) {
        resolve({
          status: 404,
          message: "Not found",
        });
      }
      resolve({
        status: 200,
        message: "Credentials created successfully.",
      });
    } catch (error) {
      resolve({
        status: 500,
        message: error.message,
      });
    }
  });
};

export const getOfflineGraceExtend = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("offline-grace-extend").find(params);
      resolve({
        status: 200,
        message: "Get Offline Grace Extend",
        response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getCustomerGraceRequest = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("customer-grace-request").find(params);
      resolve({
        message: "Customer Grace Request",
        response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getProductLicenseRenew = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("product-license-renew").find(params);
      resolve({
        message: "Product License Renew",
        response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getMonthlyReportData = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("get-monthly-report").find(params);
      resolve({
        message: "Data",
        response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getMonthlyReportSite = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("defs").find(params);
      resolve({
        message: "Data",
        response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getGuestData = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find(params);
      resolve({
        message: "Data",
        response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

// Call backend service to update evaluation result in user-logs
export const updateLog = async (data, site_uuid, uid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").patch(null, data, {
        query: {
          site_uuid,
          uid,
        },
      });

      console.log("response", response);
      if (response.length == 0) {
        resolve({
          status: 404,
          message: "Not found",
        });
      }
      resolve({
        status: 200,
        message: "Score updated successfully.",
      });
    } catch (error) {
      resolve({
        status: 500,
        message: error.message,
      });
    }
  });
};
